<template>
  <b-container fluid class="p-0">
    <b-row no-gutters>
      <b-col>
        <VBox>
          <b-container>
            <b-row>
              <b-col style="height: 110px" md="6" class="pt-4">
                <label>{{$tr('test','Test')}}</label>
              </b-col>
            </b-row>
          </b-container>
        </VBox>
      </b-col>

    </b-row>

    <FooterNavbar data-test-path="admin-organizations-footer">
      <CloseButton @close="cancel"></CloseButton>
    </FooterNavbar>
  </b-container>
</template>

<script>

import Activity from "@/activity/Activity";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import VBox from "@/components/VBox";
import FileUpload from "@/components/FileUpload";


export default {
  name: "DataExport",
  components: {FileUpload, VBox, CloseButton, FooterNavbar},

  async mounted() {
    for(let form of FormsLoader.forms){
      this.listOfForms.push({value: form, text: form.formTitle});
    }
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      return $tr('dataExport','Data export');
    },

    cancel() {
      this.close();
    },

    uploadFile(){
    },

  },

  data: () => ({
    selectedForm: null,
    listOfForms: [],
    loading: false,
    percentDone: null
  }),

}

</script>

<style scoped>

</style>